import { IntegrationFragment } from "../../../types";

export const getIntegrationInput = (integrations: readonly IntegrationFragment[]) =>
  integrations.map(({ externalOrgId, type }) => {
    return {
      externalOrgId,
      type,
    };
  });
